/* globals imagesLoaded */

/**
 * An extension to the angular-bootstrap carousel directive, that:
 *  - loads the initial slide's image once the directive has loaded
 *  - loads the remaining slides images once the first image has loaded
 *  - once all images have loaded, starts auto paging the carousel
 *
 * Assumes html in the format provided in homepageCarousel
 */
(function() {
    'use strict';
    angular.module('vhols')
        .directive('carouselPreload', ['$timeout', function($timeout) {
            return {
                scope: true,
                link: function($scope, $el, $attrs, $ctrl) {

                    $scope.$on('clockShow', function() {
                        $scope.clockShow = true;
                    });

                    // The initial interval for the carousel is set to 0 (don't change slides).
                    // This is updated once subsequent images have loaded.
                    $scope.preloadInterval = 0;
                    // We need to wait for the inner carousel directive to finish transclusion before calling imagesLoaded
                    $timeout(function () {
                        // DOM has finished rendering
                        var slidesDom = $el[0].querySelectorAll('.carousel-inner > .carousel-slide');
                        // Load first slide img
                        var imgElement = slidesDom[0].querySelector('img');
                        if (imgElement.hasAttribute('data-src')) {
                            imgElement.setAttribute('src', imgElement.getAttribute('data-src'));
                        }
                        // Wait for first image to load
                        imagesLoaded(imgElement, function() {
                            // Load all other slide images
                            for(var i = 1; i < slidesDom.length; i++) {
                                var imgElement = slidesDom[i].querySelector('img');
                                imgElement.setAttribute('src', imgElement.getAttribute('data-src'));
                            }
                            // Wait for all images to load
                            imagesLoaded(slidesDom, function() {
                                // Start the carousel
                                $scope.preloadInterval = $el.attr('loaded-interval');
                                $scope.$apply();
                            });
                        });
                    });
                }
            };
        }]);
})();
